let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("74Iit")).then(() => parcelRequire('dfmeK'));